// @flow

import * as React from 'react';

export type Context = {
  // we lock the Layout to avoid orga change
  // this is useful for config or checkout steps
  locked: boolean,
};

export default (React.createContext({
  locked: false,
}): React.Context<Context>);
